import styled, { css } from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const TableStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  overflow: visible;

  ::-webkit-scrollbar {
    width: 10px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${VARIABLES.COLORS.GRAY_2};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${VARIABLES.COLORS.BLUE_1};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${VARIABLES.COLORS.BLUE_4};
  }

  /* Child element styles
  ------------------------------- */
  .table {
    margin-bottom: 1rem;

    ${props => {
      return css`
        min-width: ${props.setWidth ? props.setWidth : '1000px'};
        max-height: ${props.setHeight ? props.setHeight : 'unset'};
      `
    }}
  }
  /* Modifiers
  ------------------------------- */
  &.is-scrollbar {
    overflow: auto;
    width: 100%;
  }

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const TableRowStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  ${props => {
    return css`
      align-items: ${props.setAlign ? props.setAlign : 'center'};
    `
  }}/* Child element styles
  ------------------------------- */
  /* Modifiers
  ------------------------------- */
  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const TableColumnStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  flex: 1;
  min-height: 60px;
  padding: 0.5rem 1rem;
  ${props => {
    return css`
      align-items: ${props.setAlign ? props.setAlign : 'center'};
    `
  }}
  /* Child element styles
  ------------------------------- */
  .table-sort-button {
    margin-right: 10px;
    cursor: pointer;
    transition: all ease 0.5s;

    .sort-descending {
      transform: rotate(180deg);
    }
  }

  /* Modifiers
  ------------------------------- */
  .ellipsis-items {
    display: table;
    table-layout: fixed;
    width: 100%;
  }

  .ellipsis-item {
    /* flex: 1; */
    display: table-cell;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* Start width table */
  &.w-80 {
    flex: 0 0 80px;
    max-width: 80px;
  }

  &.w-100 {
    flex: 0 0 100px;
    max-width: 100px;
  }

  &.w-150 {
    flex: 0 0 10%;
    max-width: 10%;
  }

  &.w-200 {
    flex: 0 0 200px;
    max-width: 200px;
  }

  &.w-250 {
    flex: 0 0 15%;
    max-width: 15%;
  }

  &.w-300 {
    flex: 0 0 300px;
    max-width: 300px;
  }

  &.w-15p {
    flex: 0 0 15%;
    max-width: 15%;
  }

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
export const TableColumnHeadStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  cursor: default;
  width: auto;
  font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
  color: ${VARIABLES.COLORS.BLUE_1};
  height: 45px;
  background-color: ${VARIABLES.COLORS.GRAY_6};
  padding: 0 14px;
  display: flex;
  align-items: center;
  line-height: 1.2;
  flex: 1;
  text-transform: uppercase;

  /* Child element styles
  ------------------------------- */
  .sort-icon {
    width: 11px;
    margin-left: 6px;
    transition: ${VARIABLES.TRANSITIONS.FAST} all;
    transform: translateY(0) rotate(180deg);
  }

  /* Modifiers
  ------------------------------- */
  &:first-child {
    border-top-left-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-bottom-left-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  &:last-child {
    border-top-right-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
    border-bottom-right-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
  }

  /* Start width table */
  &.w-80 {
    flex: 0 0 80px;
    max-width: 80px;
  }

  &.w-100 {
    flex: 0 0 100px;
    max-width: 100px;
  }

  &.w-150 {
    flex: 0 0 10%;
    max-width: 10%;
  }

  &.w-200 {
    flex: 0 0 200px;
    max-width: 200px;
  }

  &.w-250 {
    flex: 0 0 15%;
    max-width: 15%;
  }

  &.w-300 {
    flex: 0 0 300px;
    max-width: 300px;
  }

  &.w-15p {
    flex: 0 0 15%;
    max-width: 15%;
  }

  /* State
  ------------------------------- */
  &.is-sortable {
    cursor: pointer;

    &.is-desc {
      .sort-icon {
        transform: translateY(0);
      }
    }

    &.is-asc {
      .sort-icon {
        transform: translateY(0) rotate(180deg);
      }
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    height: 43px;
    padding: 0 12px;

    .sort-icon {
      width: 10px;
      margin-left: 5px;
    }
  }

  @media all and (max-width: 1440.98px) {
    min-height: 41px;
    height: auto;
    padding: 3px 11px;

    .sort-icon {
      width: 9px;
    }
  }

  @media all and (max-width: 1366.98px) {
    min-height: 40px;
    padding: 3px 10px;

    .sort-icon {
      width: 8px;
      margin-left: 4px;
    }
  }

  @media all and (max-width: 1280.98px) {
    min-height: 39px;
    padding: 3px 8px;

    .sort-icon {
      width: 7px;
    }
  }

  @media all and (max-width: 1024.98px) {
    min-height: 38px;
    padding: 2px 5px;
  }
`

export const TBodyStyle = styled.div`
  .table-row:nth-child(even) {
    background-color: ${VARIABLES.COLORS.GRAY_6};
    border-radius: 5px;
  }
`

export const THeadStyle = styled.div`
  /* Parent
  ------------------------------- */
  /* font-weight: 700;
  min-height: 60px; */
  background-color: ${VARIABLES.COLORS.GRAY_6};
  border-radius: 5px;
  /* line-height: 1; */
  /* Childrens
  ------------------------------- */
  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const TFootStyle = styled.div`
  /* Parent
  ------------------------------- */
  /* Childrens
  ------------------------------- */
  /* .table-row:nth-child(even) {
    background-color: #f7f7f7;
    border-radius: 5px;
  } */
  /* Modifiersß
  ------------------------------- */
  /* Media queries
  ------------------------------- */
`
